import React from 'react';
import { CancellationSaverRule } from '../types';

interface CancellationSaverProps {
  rule: CancellationSaverRule;
  onUpdate: (updates: Partial<CancellationSaverRule>) => void;
}

const CancellationSaver: React.FC<CancellationSaverProps> = ({ rule, onUpdate }) => {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-[3rem] border border-slate-200 dark:border-slate-700 shadow-xl shadow-slate-100/50 dark:shadow-none p-8 space-y-8">
      <div className="flex justify-between items-center">
        <div>
          <h3 className="text-lg font-black text-slate-900 dark:text-white uppercase tracking-tight">Cancellation Saver</h3>
          <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest mt-0.5">Configure retention offers</p>
        </div>
        <div className="flex items-center gap-4">
          <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Enabled</label>
          <button 
            onClick={() => onUpdate({ isEnabled: !rule.isEnabled })}
            className={`w-14 h-7 rounded-full relative p-1 transition-all ${rule.isEnabled ? 'bg-indigo-600 shadow-lg shadow-indigo-100' : 'bg-slate-200'}`}
          >
            <div className={`w-5 h-5 bg-white rounded-full shadow-md transition-transform ${rule.isEnabled ? 'translate-x-7' : 'translate-x-0'}`} />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Offer Type</label>
          <select 
            value={rule.offerType}
            onChange={(e) => onUpdate({ offerType: e.target.value as any })}
            className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold"
          >
            <option value="discount">Discount</option>
            <option value="credit">Wallet Credit</option>
            <option value="pause">Pause Subscription</option>
            <option value="snooze">Account Snooze</option>
          </select>
        </div>

        {rule.offerType === 'discount' && (
          <div className="space-y-2">
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Discount Value (%)</label>
            <input 
              type="number"
              value={rule.discountValue || 0}
              onChange={(e) => onUpdate({ discountValue: parseInt(e.target.value) })}
              className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold"
            />
          </div>
        )}

        {rule.offerType === 'credit' && (
          <div className="space-y-2">
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Credit Amount ($)</label>
            <input 
              type="number"
              value={rule.creditAmount || 0}
              onChange={(e) => onUpdate({ creditAmount: parseInt(e.target.value) })}
              className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold"
            />
          </div>
        )}

        {rule.offerType === 'pause' && (
          <div className="space-y-2">
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Pause Months</label>
            <input 
              type="number"
              value={rule.pauseMonths || 0}
              onChange={(e) => onUpdate({ pauseMonths: parseInt(e.target.value) })}
              className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold"
            />
          </div>
        )}

        {rule.offerType === 'snooze' && (
          <div className="space-y-2">
            <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Snooze Days</label>
            <input 
              type="number"
              value={rule.snoozeDays || 0}
              onChange={(e) => onUpdate({ snoozeDays: parseInt(e.target.value) })}
              className="w-full p-4 bg-slate-50 border border-slate-200 rounded-xl text-xs font-bold"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default CancellationSaver;
